import { Trans } from 'react-i18next';
import { StatusKind, MonitoringType } from 'routes/Dashboard/Monitoring/enums';

const getMapTabs = ({ statusKind }: { statusKind?: StatusKind }) => {
  let labelKey = 'by-anomalies';
  if (statusKind === StatusKind.WarningAndAlert) {
    labelKey = 'by-warning-and-alert';
  } else if (statusKind === StatusKind.Warning) {
    labelKey = 'by-warning';
  } else if (statusKind === StatusKind.Alert) {
    labelKey = 'by-alert';
  } else if (statusKind === StatusKind.DeadlineMissed) {
    labelKey = 'by-deadline-missed';
  }
  return [
    {
      label: <Trans i18nKey={labelKey} />,
      value: MonitoringType.Anomaly,
    },
    {
      label: <Trans i18nKey="by-performance" />,
      value: MonitoringType.Performance,
    },
  ];
};

export default getMapTabs;
